import { Component, Input, OnInit, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { ApiService } from "src/app/api.service";
import { DvsUtilities } from "src/app/dvs-utilities";
import { ActionButtonComponent } from "src/app/shared/action-button/action-button.component";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-asset-firmware",
	templateUrl: "./asset-firmware.component.html",
	styleUrls: ["./asset-firmware.component.scss"],
	imports: [ActionButtonComponent, FormsModule]
})
export class AssetFirmwareComponent implements OnInit {
	private api = inject(ApiService);

	@Input()
	asset: APIResults.Asset;

	public assetFirmwareInfo: APIResults.AssetFirmwareInfo;
	public selectedFirmware: APIResults.FirmwareTargetInfo;

	public selectFwControl: boolean;
	public selectFwWebpage: boolean;
	public selectFwRegime: boolean;
	public selectFwState: boolean;
	public selectDescribe: boolean;
	public selectIdent: boolean;

	public enableControl = true;
	public enableRegime = true;
	public enableDescribe = true;
	public enableIdent = true;

	public errormessage: string;

	async ngOnInit(): Promise<void> {
		await this.RefreshData();
	}

	async RefreshData(): Promise<void> {
		this.errormessage = undefined;
		try {
			this.assetFirmwareInfo = await this.api.GetAssetFirmwareInfo(this.asset.asset_id);
			if (this.assetFirmwareInfo && this.assetFirmwareInfo.firmware && this.assetFirmwareInfo.firmware.length > 0 && this.assetFirmwareInfo.currentTarget) {
				this.selectedFirmware = this.assetFirmwareInfo.firmware.find(fw => fw.controlTarget === this.assetFirmwareInfo.currentTarget);
			}
		} catch (err) {
			this.assetFirmwareInfo = null;
			this.errormessage = DvsUtilities.GetRemoteErrorMessage(err, "Couldn't load firmware info");
		}
	}

	async CancelCommand() {
		await this.api.CancelCommand(this.asset.asset_id);
		await this.RefreshData();
	}

	async CreateCommand() {
		if (this.selectIdent && !this.asset.asset_serial_number) {
			throw new Error("The asset serial number must be set before the 'Ident' command can be sent.");
		}
		await this.api.CreateCommand(this.asset.asset_id, {
			path: this.selectedFirmware?.path,
			controlTarget: this.selectedFirmware?.controlTarget,
			regimeTarget: this.selectedFirmware?.regimeTarget,
			stateTarget: this.selectedFirmware?.stateTarget,
			control: this.selectFwControl ? this.selectedFirmware.control : undefined,
			webpage: this.selectFwWebpage ? this.selectedFirmware.webpage : undefined,
			regime: this.selectFwRegime ? this.selectedFirmware.regime : undefined,
			state: this.selectFwState ? this.selectedFirmware.state : undefined,
			describe: this.selectDescribe,
			ident: this.selectIdent,
		});
		this.selectFwControl = false;
		this.selectFwWebpage = false;
		this.selectFwRegime = false;
		this.selectFwState = false;
		this.selectDescribe = false;
		this.selectIdent = false;
		this.enableControl = true;
		this.enableRegime = true;
		this.enableDescribe = true;
		this.enableIdent = true;
		await this.RefreshData();
	}

	async CreateZip() {
		if (this.selectIdent && !this.asset.asset_serial_number) {
			throw new Error("The asset serial number must be set before the 'Ident' command can be sent.");
		}
		await this.api.CreateZip(this.asset.asset_id, {
			path: this.selectedFirmware?.path,
			controlTarget: this.selectedFirmware?.controlTarget,
			regimeTarget: this.selectedFirmware?.regimeTarget,
			stateTarget: this.selectedFirmware?.stateTarget,
			control: this.selectFwControl ? this.selectedFirmware.control : undefined,
			webpage: this.selectFwWebpage ? this.selectedFirmware.webpage : undefined,
			regime: this.selectFwRegime ? this.selectedFirmware.regime : undefined,
			state: this.selectFwState ? this.selectedFirmware.state : undefined,
			describe: this.selectDescribe,
			ident: this.selectIdent,
		});
	}

	async UploadConfig(file: File) {
		await this.api.UploadOBCUConfigFile(this.asset.asset_id, file);
		await this.RefreshData();
	}

	checkControl() {
		if (this.selectFwControl || this.selectFwWebpage) {
			this.selectFwRegime = false;
			this.selectFwState = false;
			this.selectDescribe = false;
			this.selectIdent = false;

			this.enableControl = true;
			this.enableRegime = false;
			this.enableDescribe = false;
			this.enableIdent = false;
		} else {
			this.enableControl = true;
			this.enableRegime = true;
			this.enableDescribe = true;
			this.enableIdent = true;
		}
	}

	checkRegime() {
		if (this.selectFwRegime || this.selectFwState) {
			this.selectFwControl = false;
			this.selectFwWebpage = false;
			this.selectDescribe = false;
			this.selectIdent = false;

			this.enableControl = false;
			this.enableRegime = true;
			this.enableDescribe = false;
			this.enableIdent = false;
		} else {
			this.enableControl = true;
			this.enableRegime = true;
			this.enableDescribe = true;
			this.enableIdent = true;
		}
	}

	checkDescribe() {
		if (this.selectDescribe) {
			this.selectFwControl = false;
			this.selectFwWebpage = false;
			this.selectFwRegime = false;
			this.selectFwState = false;
			this.selectIdent = false;

			this.enableControl = false;
			this.enableRegime = false;
			this.enableDescribe = true;
			this.enableIdent = false;
		} else {
			this.enableControl = true;
			this.enableRegime = true;
			this.enableDescribe = true;
			this.enableIdent = true;
		}
	}

	checkIdent() {
		if (this.selectIdent) {
			this.selectFwControl = false;
			this.selectFwWebpage = false;
			this.selectFwRegime = false;
			this.selectFwState = false;
			this.selectDescribe = false;

			this.enableControl = false;
			this.enableRegime = false;
			this.enableDescribe = false;
			this.enableIdent = true;
		} else {
			this.enableControl = true;
			this.enableRegime = true;
			this.enableDescribe = true;
			this.enableIdent = true;
		}
	}
}

